



























import { Component, Vue, Watch } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({})
export default class MenuBar extends Vue {
    private linkPadding: string = "2.5rem";
    private fontSize: number = 1.4;
    private isOpen: boolean = false;

    @State("scrollPosition")
    private scrollPosition: number;

    public toggleMenuBar() : void {
        this.isOpen = !this.isOpen;
    }

    @Watch("scrollPosition")
    private handleScrollPositionChange() {
        const calculatedLinkPadding = 2.5 - this.scrollPosition / 400;
        const calculatedFontSize = 1.4 - this.scrollPosition / 400;
        this.linkPadding = (calculatedLinkPadding > 1 ? calculatedLinkPadding : 1 ) + "rem";
        this.fontSize = calculatedFontSize > 1.1 ? calculatedFontSize : 1.1;
    }
}
